import React, { Fragment } from 'react';
import { func, any } from 'prop-types';
import { UTLabel } from '@widergy/energy-ui';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import { actionCreators as userFormActions, formPropType } from 'redux/userFormHandlers';
import { PROCEDURE } from 'constants/common';

import EjesaSocialRate from './layout';
import styles from './styles.module.scss';
import { firstFieldsGroup, secondFieldsGroup } from './constants';

const fields = [...firstFieldsGroup, ...secondFieldsGroup];

const EjesaSocialRateContainer = ({ form, onCancel, dispatch, fieldValues }) => {
  const handleSubmit = values => {
    dispatch(userFormActions.submitPublicForm(values, fields, PROCEDURE, null, form));
  };
  return (
    <Fragment>
      <UTLabel large bold className={styles.title}>
        {form.name}
      </UTLabel>
      <EjesaSocialRate onSubmit={handleSubmit} onCancel={onCancel} fieldValues={fieldValues} />
    </Fragment>
  );
};

EjesaSocialRateContainer.propTypes = {
  form: formPropType,
  onCancel: func,
  fieldValues: any // eslint-disable-line react/forbid-prop-types
};

const formSelector = formValueSelector('EJESA_SOCIAL_RATE');

const mapStateToProps = store => ({
  fieldValues: formSelector(store, ...fields.map(field => `id${field.id}`))
});

export default connect(mapStateToProps)(EjesaSocialRateContainer);
